export default __webpack_public_path__ + "static/media/Arro_Icon.99a6ca24.png";